/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RemoveCustomersFromPoolRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {RemoveCustomersFromPoolResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const removeCustomersFromPool = (request: RemoveCustomersFromPoolRequest, options?: CashRequestOptions) => post<RemoveCustomersFromPoolRequest, RemoveCustomersFromPoolResponse>("/2.0/cash/remove-customers-from-pool", request, {...options, rejectOnError: true })